export enum ProductStatus {
  Green = 'Green',
  Yellow = 'Yellow',
  Red = 'Red',
  Blue = 'Blue',
}
